import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, Button, ButtonGroup, CircularProgress, Dialog, DialogContent, InputLabel, List, ListItem, Paper, Snackbar, Stack, Tab, Tabs, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"

import videoImage from '../../../../public/assets/images/videoPageImg.png'
import ManagerPendingVideoFeatured from '../../../../components/ManagerPendingVideoFeatured/ManagerPendingVideoFeatured'
import CopyIndexIcon from '../../../../public/assets/icons/CopyIndexIcon'
import ApproveIcon from '../../../../public/assets/icons/ApproveIcon'
import WebsiteIcon from '../../../../public/assets/icons/WebsiteIcon'
import InquireIcon from '../../../../public/assets/icons/InquireIcon'
import RejectIcon from '../../../../public/assets/icons/RejectIcon'
import MessageLineIcon from '../../../../public/assets/icons/MessageLineIcon'
import DownloadVideoIcon from '../../../../public/assets/icons/DownloadVideoIcon'
import DownloadAgreement from '../../../../public/assets/icons/DownloadAgreement'
import VideoUrlIcon from '../../../../public/assets/icons/VideoUrlIcon'
import FileAttachIcon from '../../../../public/assets/icons/FileAttachIcon'
import AddPlusIcon from '../../../../public/assets/icons/AddPlusIcon'
import TextZoomIcon from '../../../../public/assets/icons/TextZoomIcon'
import BtnTickIcon from '../../../../public/assets/icons/BtnTickIcon'
import InfoIcon from '../../../../public/assets/icons/InfoIcon'
import CancelBackIcon from '../../../../public/assets/icons/CancelBackIcon'
import NoteEditIcon from '../../../../public/assets/icons/NoteEditIcon'
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import BtnCrossIcon from '../../../../public/assets/icons/BtnCrossIcon'
import { color, height, style } from '@mui/system'
import SolidCrrossIcon from '../../../../public/assets/icons/SolidCrrossIcon'
import DownloadFileIcon from '../../../../public/assets/icons/DownloadFileIcon'
import NoteEditIconBW from '../../../../public/assets/images/noteediticon.svg'
import styles from '../../../../styles/pages/user/qcagentdashboard/qcsubmmitedinquiringvideopage.module.scss'
import modalStyyle from '../../../../styles/layout/modal/qcsubmitinquiringvideomodal.module.scss'
import ConvoPartnerIcon from '../../../../ui/Icons/ConvoPartnerIcon'
import LongArrow from '../../../../ui/Icons/LongArrow'
import ExpandMoreIcon from '../../../../public/assets/icons/ExpandMoreIcon'
import Signature from '../../../../public/assets/images/signature2.png'
import DownloadIcon from '../../../../ui/Icons/DownloadIcon'
import CopyWriterIcon from '../../../../ui/Icons/CopyWriterIcon'
import CopyWriterEditorIcon from '../../../../ui/Icons/CopyWriterEditorIcon'
import CancelIcon from '../../../../ui/Icons/CancelIcon'
import AlertBtnIcon from '../../../../ui/Icons/AlertBtnIcon'
import CancelIconViolet from '../../../../ui/Icons/CancelIconViolet'
import ExclamatoryIcon from '../../../../ui/Icons/ExclamatoryIcon'
import CrossIcon from '../../../../ui/Icons/CrossIcon'
import TextAreaCrossIcon from '../../../../ui/Icons/TextAreaCrossIcon'
import CancelIconRed from '../../../../ui/Icons/CancelIconRed'
import WebsiteIconTwo from '../../../../public/assets/icons/WebsiteIconTwo'
import { PdfMainIcon } from '../../../../ui/Icons/PdfMainIcon'
import { PdfDownloadIcon } from '../../../../ui/Icons/PdfDownloadIcon'
import { PdfViewIcon } from '../../../../ui/Icons/PdfViewIcon'
import { AgreementIcon } from '../../../../ui/Icons/AgreementIcon'
import { DeketeIcon } from '../../../../public/assets/icons/DeketeIcon'
import MinimizeIcon from '../../../../public/assets/icons/MinimizeIcon'
import { NoteEditIconBw } from '../../../../public/assets/icons/NoteEditIconBw'
import { NoteDeleteIcon } from '../../../../public/assets/icons/NoteDeleteIcon'
import { NoteViewIcon } from '../../../../public/assets/icons/NoteViewIcon'
import { QcAgentApprovedVideoFeatured } from '../../../../components/ManagerPendingVideoFeatured/QcAgentApprovedVideoFeatured/QcAgentApprovedVideoFeatured'
import { RejectedBackIcon } from '../../../../public/assets/icons/RejectedBackIcon'
import RejectSaveIcon from '../../../../public/assets/images/rejectedsaveicon.svg'
import RejectBackIcon from '../../../../public/assets/images/rejectedbackicon.svg'
import InquireSaveIcon from '../../../../public/assets/images/inquiresaveicon.svg'
import InquireBackIcon from '../../../../public/assets/images/inquirebackicon.svg'
import ApproveWebSaveIcon from '../../../../public/assets/images/approvewebsitesaveicon.svg'
import ApproveWebBackIcon from '../../../../public/assets/images/approvewebsitebackicon.svg'
import { QcSubmittedInquiringFeatVideo } from '../../../../components/QcSubmittedInquiringFeatVideo/QcSubmittedInquiringFeatVideo'
import { WebsiteIconThree } from '../../../../public/assets/icons/WebsiteIconThree'
import CalenderGrayIcon from '../../../../ui/Icons/CalenderGrayIcon'
import ReadIcon from '../../../../ui/Icons/ReadIcon'
import { ExclametoryGreenicon } from '../../../../ui/Icons/ExclametoryGreenicon'
import { ExclametoryRedIcon } from '../../../../ui/Icons/ExclametoryRedIcon'
import { ExclametoryViolet } from '../../../../ui/Icons/ExclametoryViolet'

const OriginalVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        }
    },
}));

const SocialVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        },
        [`& .text_top`]: {
            margin: '0 0 15px',
        },
        [`& .text_btm`]: {
            color: '#696969',
        }
    },
}));

const PostInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 199,
        borderRadius: "10px 10px 0 10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important"
    },
}));

const VideoAddTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 126,
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important"
    },
}));

const CopyUrlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 119,
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));

const CloseTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 59,
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));

const PdfTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 146,
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));


const SaveTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        width: 54,
        maxWidth: 54,
        textAlign: "center",
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));

const CancelTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        width: 66,
        maxWidth: 66,
        textAlign: "center",
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));

const EditTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        width: 49,
        maxWidth: 49,
        textAlign: "center",
        borderRadius: "5px",
        color: "#000",
        boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important",
        fontWeight: '500 '
    },
}));

const ownershipdata = [
    {
        head: 'The person who filmed this video is ',
        content: 'Me'
    },
    {
        head: 'Are There People Appearing In the Video?  ',
        content: 'No'
    },
    {
        head: 'Did You Send/Submit/Upload This Video To A Website And/Or Social Media Account?   ',
        content: 'No, I did not'
    },
    {
        head: 'Did Anyone Reach You About Using This Video?   ',
        content: 'No, You Are The First Company'
    },
    {
        head: 'Did You Sign A Licensing Agreement For This Video With Another Company/Page?   ',
        content: 'No, I Did Not'
    },
]

const attachFileLoop = [
    {
        fileName: "5028537_5563370603774986.png"
    }
]


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}



function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "62px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0"
            }
        }
    },
};


export const QcSubmittedInquiringVideoPage = () => {
    const [rejectNoteBoolean , setRejectedNoteBoolean] = React.useState(false)

    const [inquireNoteBoolean , setInquireNoteBoolean] = React.useState(false)

    const [websiteNoteBoolean , setWebsiteNoteBoolean] = React.useState(false)

    const [noteCopyrihtPanel , setNoteCopyrightaPanel] = React.useState(false)

    const [deleteNoteBoolean , setDeleteNoteBoolean] = React.useState(true)

    const handlenoteCopyrihtPanel = () =>  {
        setNoteCopyrightaPanel((prevCondition)=> !prevCondition)
    }

    const [noteEditorPanel , setNoteEditorPanel] = React.useState(false)

    const handleNoteEditorPanel = () =>  {
        setNoteEditorPanel((prevCondition)=> !prevCondition)
    }

    const [unreachable, setUnreachable] = React.useState(true)

    const [copywriteHighlight, setCopywriteHighlight] = React.useState(false)

    const [copywriteHighligtOther, setCopywriteHighlightOther] = React.useState(true)

    const [copywriteHighlightAddMore, setCopywriteHighlightAddMore] = React.useState(false)

    const [videoactive,setVideoActive] = React.useState(true)

    // const [justufyOne, setJustifyOne] = React.useState(false)

    // const [justufyTwo, setJustifyTwo] = React.useState(true)

    // const [disableAproveBox, setDisableApproveBox] = React.useState(false)

    const handleVideoActivate = () => {
        setVideoActive(false)
    }

    const [snackBarstate, setsnackBarState] = React.useState({
        snackOpen: false,
        vertical: 'center',
        horizontal: 'center',
    });
    const { vertical, horizontal, snackOpen } = snackBarstate;

    const handleSnackClick = (newState) => () => {
        setsnackBarState({ ...newState, snackOpen: true });
    };

    const [expanded, setExpanded] = React.useState(false);

    const handleChange =
        (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

    const [teamMsg, setTeamMsg] = React.useState(0);

    const handleTeamMsg = (event, newValue) => {
        setTeamMsg(newValue);
    };

    const [teamMsg1, setTeamMsg1] = React.useState(0);

    const handleTeamMsg1 = (event, newValue) => {
        setTeamMsg1(newValue);
    };

    const handleSnackClose = () => {
        setsnackBarState({ ...snackBarstate, snackOpen: false });
    };

    const [snackBarstateTwo, setsnackBarStateTwo] = React.useState({
        snackOpenTwo: false,
        vertical: 'center',
        horizontal: 'center',
    });
    const { verticalTwo, horizontalTwo, snackOpenTwo } = snackBarstateTwo;

    const handleSnackClickTwo = (newState) => () => {
        setsnackBarStateTwo({ ...newState, snackOpenTwo: true });
    };

    const handleSnackCloseTwo = () => {
        setsnackBarStateTwo({ ...snackBarstateTwo, snackOpenTwo: false });
    };

    const [snackBarstateThree, setsnackBarStateThree] = React.useState({
        snackOpenThree: false,
        verticalThree: 'center',
        horizontalThree: 'center',
    });
    const { verticalThree, horizontalThree, snackOpenThree } = snackBarstateThree;

    const handleSnackClickThree = (newState) => () => {
        setsnackBarStateThree({ ...newState, snackOpenThree: true });
    };

    const handleSnackCloseThree = () => {
        setsnackBarStateThree({ ...snackBarstateThree, snackOpenThree: false });
    };

    const [modalopen, setModalopen] = React.useState(false);

    const handleClickModalOpen = () => {
        setModalopen(true);
    };

    const handleCloseModal = () => {
        setModalopen(false);
    };

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [openSecond, setOpenSecond] = React.useState(false);
    const handleOpenSecond = () => setOpenSecond(true);
    const handleCloseSecond = () => setOpenSecond(false);

    const handleSecondModal = () => {
        handleOpenSecond();
        handleClose();
    }

    const [openThird, setOpenThird] = React.useState(false);
    const handleOpenThird = () => setOpenThird(true);
    const handleCloseThird = () => setOpenThird(false);

    const handleThirdModal = () => {
        handleOpenThird();
        handleClose();
    }

    const [openFourth, setOpenFourth] = React.useState(false);
    const handleOpenFourth = () => setOpenFourth(true);
    const handleCloseFourth = () => setOpenFourth(false);

    const [openFifth, setOpenFifth] = React.useState(false);
    const handleOpenFifth = () => setOpenFifth(true);
    const handleCloseFifth = () => setOpenFifth(false);

    const handleFifthModal = ()=> {
        handleOpenFifth()
        handleCloseFourth()
    }



    const [openProceed, setOpenProceed] = React.useState(false);
    const handleClickOpenProceed = () => {
        setOpenProceed(true);
    };

    const [tabValue, setTabValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const [value, setValue] = React.useState("");
    const [lisitem, setListItem] = React.useState([]);
    const [listIndex, setListIndex] = React.useState(-1);

    const addList = () => {
        setListItem([...lisitem, value]);
        setValue("");
    };

    const removeItem = (index) => {
        setListIndex(index);
    };

    useEffect(() => {
        const filterList = lisitem.filter((data, index) => index !== listIndex);
        setListItem(filterList);
        setListIndex(-1);
    }, [listIndex]);

    const [socialValue, setsocialValue] = React.useState("");
    const [socialLisitem, setsocialListItem] = React.useState([]);
    const [socialListIndex, setsocialListIndex] = React.useState(-1);

    const addListsocial = () => {
        setsocialListItem([...socialLisitem, value]);
        setsocialValue("");
    };

    const removeItemsocial = (index) => {
        setsocialListIndex(index);
    };

    useEffect(() => {
        const filterList = socialLisitem.filter((data, index) => index !== socialListIndex);
        setsocialListItem(filterList);
        setsocialListIndex(-1);
    }, [socialListIndex]);
    return (
        <>
            <Box className={styles.pageCopyVideo}>
                <PerfectScrollbar className={styles.videoDetailsScroll}>
                    <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        className={styles.copywritterVideoWrapper}
                    >
                        <Box className={styles.videoColLeft}>
                            <Paper className={styles.vdoCard}>
                                <Box className={styles.videoBox} onClick={handleClickOpenProceed}>
                                    <img src={videoImage} width={701} height={435} alt="" />
                                    <QcSubmittedInquiringFeatVideo />
                                </Box>
                                <Box className={styles.videoInput}>
                                    <input
                                        type="text"
                                        placeholder="https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                    />
                                     <CopyUrlTooltip
                                        title={
                                            "Copy Video URL"
                                        }
                                        >
                                        <Button>
                                            <CopyIndexIcon />
                                        </Button>
                                    </CopyUrlTooltip>
                                </Box>
                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.vdoDesBtngrp}>
                                    <Button onClick={handleOpen} startIcon={<ApproveIcon />} className={styles.btnApprove} 
                                        >Approve</Button>
                                    <Button onClick={handleOpenFourth} startIcon={<WebsiteIcon />} className={styles.btnWebsite}  > Website Only</Button>
                                    <Button  startIcon={<InquireIcon />} className={styles.btnInquire} disabled>Inquire</Button>
                                    <Button onClick={handleOpenSecond} startIcon={<RejectIcon />} className={styles.btnReject}  > Reject</Button>
                                </Stack>

                                <Stack
                                    direction={"row"}
                                    flexWrap={"wrap"}
                                    className={styles.vdobtnGrp}
                                >
                                    <Box className={styles.btnFristgrp}>
                                        {/* <Button className={styles.msgcopyBtn} endIcon={<ConvoPartnerIcon />}>Convo w/ Partner</Button> */}
                                        <Button className={styles.msgcopyBtn} startIcon={<MessageLineIcon />}>Message Partner</Button>
                                        <Button className={styles.msgcopyBtn} startIcon={<MessageLineIcon />}>Message Admin</Button>
                                        <Button  className={styles.msgcopyBtn} startIcon={<MessageLineIcon />}>Message Manager</Button>
                                    </Box>
                                </Stack>
                                <Stack
                                    direction={"row"}
                                    flexWrap={"wrap"}
                                    className={styles.dwnldbtnGrp}>
                                    <Button className={styles.vdoDwnldBtn} startIcon={<DownloadVideoIcon />}>Download Video</Button>
                                    <Button className={styles.vdoagreeBtn} startIcon={<DownloadAgreement />}>Download Redacted Agreement</Button>
                                </Stack>
                            </Paper>
                            <Box className={styles.video_alert}>
                                <Typography variant='body1' className={styles.text}>
                                    Video pending titling since January 22, 2023 at 07:56 PM UTC.
                                </Typography>
                                <SocialVideoTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography className='text_top' >You have already alerted the<br /> copywriting team on December 15,<br /> 2023 at 04:59:22 PM UTC.</Typography>
                                                <Typography className='text_btm'>You can try again in 48 hours.</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                {/* <Button  type='button' className={`${styles.alert_btn}`} startIcon={<AlertBtnIcon />}>
                                    Alert Copywriter
                                </Button> */}
                                </SocialVideoTooltip>
                            </Box>

                            <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${styles.vdoDetailsCard}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2" className={styles.headingbtn}>
                                        <span>Video Details</span>
                                        <Typography variant='caption' className={styles.btn_holder}>
                                            <Button type='button' className={videoactive ? `${styles.user_ver_btn} ${styles.active}` : styles.user_ver_btn}
                                                onClick={handleVideoActivate}
                                            >
                                                User Version
                                            </Button>
                                        </Typography>
                                    </Typography>
                                </Box>
                                <Box className={styles.vdodetailInner}>
                                    <Box className={styles.vdoUrlGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Public Post URL</Typography>
                                        <Box className={styles.videoInput}>
                                            <input
                                                type="text"
                                                placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                            />
                                            <CopyUrlTooltip
                                                title={
                                                    "Copy Video URL"
                                                }
                                                >
                                                <Button>
                                                    <CopyIndexIcon />
                                                </Button>
                                            </CopyUrlTooltip>
                                        </Box>
                                    </Box>
                                    <Box className={styles.titleGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Title</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away</Typography>
                                    </Box>
                                    <Box className={styles.descriptionGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Description:</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vitae. Integmolestie, ex sit amet semd mauris odimolestie, met semd mauris odimolestie, ex sit amet semd maurier molestie, ex sit amet semd mauris odidgfgo... <Button><TextZoomIcon /></Button></Typography>
                                    </Box>
                                    {
                                        videoactive === false ? (
                                            <Box className={styles.tagsGroup}>
                                                <Typography variant="caption" className={styles.formLabel}>Tags</Typography>
                                                <Typography variant="body2" className={styles.formPara}>Viral, Viral Snare, Viral Name 1 </Typography>
                                            </Box>
                                        ) : ''
                                    }

                                    <Stack direction={'row'} alignItems={'center'} className={styles.filmingGrid}>
                                        <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Location</Typography>
                                            <Typography variant="body2" className={styles.formPara}>Los Angeles, California, United States</Typography>
                                        </Box>
                                        <Box className={`${styles.filmingDate} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Date</Typography>
                                            <Typography variant="body2" className={styles.formPara}>January 25, 2019</Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                                {
                                    videoactive ? (
                                        <>
                                            <Box className={styles.vdoFileList}>
                                                <Typography variant="caption" className={styles.formLabel}>Website upload URL</Typography>
                                                <Box className={styles.videoInput}>
                                                    <input
                                                        type="text"
                                                        placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                                    />
                                                    <CopyUrlTooltip
                                                        title={
                                                            "Copy Video URL"
                                                        }
                                                        >
                                                        <Button>
                                                            <CopyIndexIcon />
                                                        </Button>
                                                    </CopyUrlTooltip>
                                                </Box>
                                            </Box>
                                            <Box className={styles.vdoFileList}>
                                                <Typography variant="caption" className={styles.formLabel}>YouTube upload URL</Typography>
                                                <Box className={styles.videoInput}>
                                                    <input
                                                        type="text"
                                                        placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                                    />
                                                    <CopyUrlTooltip
                                                        title={
                                                            "Copy Video URL"
                                                        }
                                                        >
                                                        <Button>
                                                            <CopyIndexIcon />
                                                        </Button>
                                                    </CopyUrlTooltip>
                                                </Box>
                                            </Box>
                                            <Box className={styles.vdoFileList}>
                                                <Typography variant="caption" className={styles.formLabel}>VS file link</Typography>
                                                <Box className={styles.videoInput}>
                                                    <input
                                                        type="text"
                                                        placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                                    />
                                                    <CopyUrlTooltip
                                                        title={
                                                            "Copy Video URL"
                                                        }
                                                        >
                                                        <Button>
                                                            <CopyIndexIcon />
                                                        </Button>
                                                    </CopyUrlTooltip>
                                                </Box>
                                            </Box>
                                        </>
                                    ) : ""
                                }
                                <Box className={styles.vdoFileList}>
                                    <InputLabel>Original Video File(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={value} onChange={(e) => setValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                        <VideoAddTooltip
                                        title={
                                            "Add Another Link"
                                        }
                                        >
                                            <Button onClick={addList}><AddPlusIcon /></Button>
                                        </VideoAddTooltip>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {lisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                    <VideoAddTooltip
                                                            title={
                                                                "Save Link"
                                                            }
                                                            >
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                     </VideoAddTooltip>
                                                        <VideoAddTooltip
                                                            title={
                                                                "Discard"
                                                            }
                                                            >
                                                        <Button onClick={() => removeItem(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                        </VideoAddTooltip>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                                <Box className={styles.vdoFileList}>
                                    <InputLabel>Social Media Post(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={socialValue} onChange={(e) => setsocialValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                        <VideoAddTooltip
                                                            title={
                                                                "Add Another Link"
                                                            }
                                                            >
                                            <Button onClick={addListsocial}><AddPlusIcon /></Button>
                                         </VideoAddTooltip>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {socialLisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                    <VideoAddTooltip
                                                            title={
                                                                "Save Link"
                                                            }
                                                            >
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                     </VideoAddTooltip>
                                                     <VideoAddTooltip
                                                            title={
                                                                "Discard"
                                                            }
                                                            >
                                                        <Button onClick={() => removeItemsocial(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                     </VideoAddTooltip>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <OriginalVideoTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">Partner is currently adding a file.<br /> Please try again in a few minutes.</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button startIcon={<VideoUrlIcon />}>Add original video file (VS Link)</Button>
                                    </OriginalVideoTooltip>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <SocialVideoTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">Partner is adding a post URL.<br /> Please try again in a few minutes.</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button startIcon={<FileAttachIcon />}>Add social media post URL</Button>
                                    </SocialVideoTooltip>
                                </Box>
                            </Paper>
                        </Box>
                        <Box className={styles.videoColRight}>
                            <Box className={styles.cmnboxborderd}>
                                <Box className={`${styles.pageMainAlert} ${styles.expandAlertThree} ${styles.expandAlert}`}>
                                    <CloseTooltip
                                            title={
                                                "Close"
                                            }
                                            >
                                        <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                    </CloseTooltip>    
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'center'} className={styles.expandHeader}>
                                        <Typography variant='body1'>You are <strong> Inquiring</strong> about this video.</Typography>
                                        <Button><CancelBackIcon />Cancel</Button>
                                    </Stack>
                                    <Box className={styles.innerNotes}>
                                        {
                                            inquireNoteBoolean ? (
                                                <>
                                                     <InputLabel>Your Notes
                                                        <CancelTooltip
                                                            title={
                                                                "Cancel"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={InquireBackIcon} alt="" />
                                                            </Button>
                                                         </CancelTooltip>
                                                         <SaveTooltip
                                                            title={
                                                                "Save"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={InquireSaveIcon} alt="" />
                                                            </Button>
                                                        </SaveTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={`${styles.noteList} ${styles.noteListbg}`}>
                                                        <ListItem disablePadding>Your notes will be shown here</ListItem>
                                                        <ListItem disablePadding>Your notes will be shown here</ListItem>
                                                    </List>
                                                    {/* <Typography variant='body1' className={styles.option_date}>
                                                        Date: March 24, 2023 at 04:45:22 PM UTC
                                                    </Typography> */}
                                                </>
                                            ) : (
                                                <>
                                                    <InputLabel>Your Notes
                                                        <EditTooltip
                                                            title={
                                                                "Edit"
                                                            }
                                                        >
                                                            <Button>
                                                                <NoteEditIcon />
                                                            </Button>
                                                        </EditTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={styles.noteList}>
                                                        <ListItem disablePadding>your notes will be shown here</ListItem>
                                                        <ListItem disablePadding>your notes will be shown here</ListItem>
                                                    </List>
                                                    {/* <Typography variant='body1' className={styles.option_date}>
                                                        Date: March 24, 2023 at 04:45:22 PM UTC
                                                    </Typography> */}
                                                            </>
                                                        )
                                                        }
                                    </Box>
                                </Box>
                                <Box className={`${styles.video_inquiry_acc} ${styles.innerNotes}`}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant='h3' className={styles.acc_heading}>
                                            You previously inquired about this video.
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={styles.custom_accordion_details}>
                                            <InputLabel>Your Notes
                                            </InputLabel>
                                            <List disablePadding className={styles.noteList}>
                                                <ListItem disablePadding>your notes will be shown here</ListItem>
                                                <ListItem disablePadding>your notes will be shown here</ListItem>
                                            </List>
                                            <Typography variant='body1' className={styles.option_date}>
                                                Date: March 24, 2023 at 04:45:22 PM UTC
                                            </Typography>   
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                                <Box className={`${styles.video_inquiry_acc} ${styles.innerNotes}`}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant='h3' className={styles.acc_heading}>
                                            (QC Agent Name] (QC Agent) previously inquired about this video.
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={styles.custom_accordion_details}>
                                            <InputLabel>[QC Agent Name]’s Notes
                                            </InputLabel>
                                            <List disablePadding className={styles.noteList}>
                                                <ListItem disablePadding>QC Agent’s notes will be shown here</ListItem>
                                                <ListItem disablePadding>QC Agent’s notes will be shown here</ListItem>
                                            </List>
                                            <Typography variant='body1' className={styles.option_date}>
                                                Date: March 24, 2023 at 04:45:22 PM UTC
                                            </Typography>   
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                                <Box className={`${styles.pageMainAlert} ${styles.expandAlertThree} ${styles.expandAlertManager} ${styles.expandAlert}`}>
                                    <CloseTooltip
                                            title={
                                                "Close"
                                            }
                                            >
                                        <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                    </CloseTooltip>    
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'center'} className={styles.expandHeader}>
                                        <Typography variant='body1'>Manager Name (Manager) is <strong> Inquiring</strong> about this video.</Typography>
                                    </Stack>
                                    <Box className={styles.innerNotes}>
                                        {
                                            inquireNoteBoolean ? (
                                                <>
                                                     <InputLabel>Your Notes
                                                        <CancelTooltip
                                                            title={
                                                                "Cancel"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={InquireBackIcon} alt="" />
                                                            </Button>
                                                         </CancelTooltip>
                                                         <SaveTooltip
                                                            title={
                                                                "Save"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={InquireSaveIcon} alt="" />
                                                            </Button>
                                                        </SaveTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={`${styles.noteList} ${styles.noteListbg}`}>
                                                        <ListItem disablePadding>Your notes will be shown here</ListItem>
                                                        <ListItem disablePadding>Your notes will be shown here</ListItem>
                                                    </List>
                                                    {/* <Typography variant='body1' className={styles.option_date}>
                                                        Date: March 24, 2023 at 04:45:22 PM UTC
                                                    </Typography> */}
                                                </>
                                            ) : (
                                                <>
                                                    <InputLabel>[Manager Name]'s Notes</InputLabel>
                                                    <List disablePadding className={styles.noteList}>
                                                        <ListItem disablePadding>Manager’s notes will be shown here</ListItem>
                                                        <ListItem disablePadding>Manager’s notes will be shown here</ListItem>
                                                    </List>
                                                    <Typography variant='body1' className={styles.option_date}>
                                                        Date: March 24, 2023 at 04:45:22 PM UTC
                                                    </Typography>
                                                            </>
                                                        )
                                                        }
                                    </Box>
                                </Box>
                                <Box className={`${styles.video_inquiry_acc} ${styles.innerNotes}`}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant='h3' className={styles.acc_heading}>
                                            Manager previously inquired about this video.
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={styles.custom_accordion_details}>
                                            <InputLabel>[Manager Name]'s Notes
                                            </InputLabel>
                                            <List disablePadding className={styles.noteList}>
                                                <ListItem disablePadding>Manager's notes will be shown here</ListItem>
                                                <ListItem disablePadding>Manager's notes will be shown here</ListItem>
                                            </List>
                                            <Typography variant='body1' className={styles.option_date}>
                                                Date: March 24, 2023 at 04:45:22 PM UTC
                                            </Typography>   
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                                {/* <Box className={styles.pageMainAlert}>
                                    <Typography variant='body1'>This video was <strong> approved</strong> on January 23, 2023 at 07:56:14 PM UTC.</Typography>
                                    <Button className={styles.alertbox_btn}>Awaiting Confirmation</Button>
                                    <CloseTooltip
                                        title={
                                            "Close"
                                        }
                                        >
                                    <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                    </CloseTooltip>
                                </Box> */}
                                {/* <Box className={styles.approveBox}>
                                    <Typography variant='caption' className={styles.first_text}>Approved</Typography>
                                    <Box className={styles.middle_div}>
                                        <Typography variant='caption' className={styles.md_top_text}>?</Typography>
                                        <Typography variant='caption' className={styles.ico}>
                                            <LongArrow />
                                        </Typography>
                                    </Box>
                                    <Typography variant='caption' className={styles.last_text}>?</Typography>
                                </Box> */}
                                <Box className={`${styles.pageMainAlert} ${styles.pageMainAlertTwo}`}>
                                    <Typography variant='body1'>You <strong> Approved</strong> this video on January 22, 2023 at 07:56 PM UTC</Typography>
                                    <Button className={styles.alertbox_btn} v startIcon={<CancelIcon />}>Cancel</Button>
                                    <CloseTooltip
                                        title={
                                            "Close"
                                        }
                                        >
                                    <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                    </CloseTooltip>
                                </Box>

                                <Box className={`${styles.pageMainAlert} ${styles.expandAlertOne} ${styles.expandAlert}`}>
                                    <CloseTooltip
                                        title={
                                            "Close"
                                        }
                                        >
                                        <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                    </CloseTooltip>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'center'} className={styles.expandHeader}>
                                        <Typography variant='body1'>You <strong>Rejected</strong>  this video on January 22, 2023 at 07:56 PM UTC</Typography>
                                        <Button><CancelBackIcon />Cancel</Button>
                                    </Stack>
                                    <Box className={styles.innerNotes}>
                                        {
                                            rejectNoteBoolean ? (
                                                <>
                                                    <InputLabel>Your Notes
                                                        <CancelTooltip
                                                            title={
                                                                "Cancel"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={RejectBackIcon} alt="" />
                                                            </Button>
                                                         </CancelTooltip>
                                                         <SaveTooltip
                                                            title={
                                                                "Save"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={RejectSaveIcon} alt="" />
                                                            </Button>
                                                        </SaveTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={`${styles.noteList} ${styles.noteListbg}`}>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                    </List>
                                                </>
                                            ) : (
                                                <>
                                                    <InputLabel>Justification 
                                                        <EditTooltip
                                                            title={
                                                                "Edit"
                                                            }
                                                        >
                                                            <Button><NoteEditIcon /></Button>
                                                        </EditTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={styles.noteList}>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                    </List>
                                                </>
                                            )
                                        }

                                    </Box>
                                </Box>
                                <Box className={`${styles.pageMainAlert} ${styles.expandAlertTwo} ${styles.expandAlert}`}>
                                        <CloseTooltip
                                        title={
                                            "Close"
                                        }
                                        >
                                            <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                        </CloseTooltip>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'center'} className={styles.expandHeader}>
                                        <Typography variant='body1'>You <strong> Approved</strong> this video for <strong> Website-only posting</strong> on January 22, 2023 at 07:56 PM UTC.</Typography>
                                        <Button><CancelBackIcon />Cancel</Button>
                                    </Stack>
                                    <Box className={styles.innerNotes}>
                                        {
                                            websiteNoteBoolean ? (
                                                <>
                                                    <InputLabel>Your Notes
                                                        <CancelTooltip
                                                            title={
                                                                "Cancel"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={ApproveWebBackIcon} alt="" />
                                                            </Button>
                                                         </CancelTooltip>
                                                         <SaveTooltip
                                                            title={
                                                                "Save"
                                                            }
                                                            >
                                                            <Button>
                                                                <img src={ApproveWebSaveIcon} alt="" />
                                                            </Button>
                                                        </SaveTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={`${styles.noteList} ${styles.noteListbg}`}>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                    </List>
                                                </>
                                            ) : (
                                                <>
                                                    <InputLabel>Justification
                                                        <EditTooltip
                                                            title={
                                                                "Edit"
                                                            }
                                                        >
                                                            <Button>
                                                                <NoteEditIcon />
                                                            </Button>
                                                        </EditTooltip>
                                                    </InputLabel>
                                                    <List disablePadding className={styles.noteList}>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                        <ListItem disablePadding>My justification will be shown here.</ListItem>
                                                    </List>
                                                </>
                                            )
                                        }
                                    </Box>
                                </Box>
                            </Box>


                            <Paper className={unreachable ? `${styles.comWhiteBox} ${styles.submitterDetails} ${styles.red_border}` : `${styles.comWhiteBox} ${styles.submitterDetails}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Submitter Details</span>
                                    </Typography>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                    <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formName}`}>
                                            <Typography variant="h6">Full Name</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formNumber}`}>
                                            <Typography variant="h6">Phone Number</Typography>
                                            <Typography variant="body2">+1 234 567 8290</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formEmail}`}>
                                            <Typography variant="h6">Email Address {unreachable ? <span className='unreach'>(Unreachable Email)</span> : ""}</Typography>
                                            <Typography variant="body2" className={styles.mailAdd}>jognsmith@gmail.com</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formSocial}`}>
                                            <Typography variant="h6">Social Media Handle</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formDob}`}>
                                            <Typography variant="h6">Date Of Birth</Typography>
                                            <Typography variant="body2">05/17/2002</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formSignature}`}>
                                            <Typography variant="h6">Signature</Typography>
                                            <img src={Signature} alt="" className={styles.signature} />
                                        </Box>
                                    </Box>
                                </Stack>
                            </Paper>


                            {/* <Box className={styles.copyright_ownership}>
                                <Box className={styles.copyright_head_box}>
                                    <Typography variant='h5' className={styles.copy_heading}>
                                        Copyrights Ownership
                                    </Typography>
                                </Box>

                                <Box className={styles.copyright_list}>
                                    {
                                        ownershipdata.map((item) => (
                                            <Box className={styles.copyright_list_single}>
                                                <Typography variant='body1' className={styles.list_head}>
                                                    {item.head}
                                                </Typography>
                                                <Typography variant='caption' className={styles.list_content}>
                                                    {item.content}
                                                </Typography>
                                            </Box>
                                        ))
                                    }

                                </Box>
                            </Box> */}

                            <Paper className={copywriteHighlight ? `${styles.comWhiteBox} ${styles.copywright} ${styles.copywritePaperHighlight}`
                            : copywriteHighligtOther ? `${styles.comWhiteBox} ${styles.copywright} ${styles.copywritePaperHighlightother}` :
                             `${styles.comWhiteBox} ${styles.copywright}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Copyrights Ownership</span>
                                    </Typography>
                                </Box>
                                <List disablePadding className={styles.ownerListItme}>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>The person who filmed this video is </Typography>
                                                {
                                                    copywriteHighligtOther ? (
                                                        <Typography variant='h4' className={styles.bgWrapTwo}>Other: My niece </Typography>
                                                    ) :
                                                    <Typography variant='body2'>Me</Typography>
                                                }
                                            </Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Are There People Appearing In the Video? </Typography>
                                                <Typography variant='body2' className={styles.bgWrap}>No</Typography>
                                            </Box>
                                            {copywriteHighlight ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Who are they? </Typography>
                                                    <Typography variant='body2' className={styles.textorng}>my friends</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did You Send/Submit/Upload This Video To A Website And/Or Social Media Account? </Typography>
                                                <Typography variant='body2'>No, I did not</Typography>
                                            </Box>
                                            {copywriteHighlightAddMore ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Where Did You Submit It? </Typography>
                                                    <Typography variant='body2' className={styles.textorngTwo}>Our Instagram, Facebook and youTube</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did Anyone Reach You About Using This Video?</Typography>
                                                <Typography variant='body2' className={styles.bgWrap}>No, You Are The First Company</Typography>
                                            </Box>
                                            {copywriteHighlight ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Please share the name of the company/page with us</Typography>
                                                    <Typography variant='body2' className={styles.textorng}>Viralhog, jukin</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>

                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did You Sign A Licensing Agreement For This Video With Another Company/Page?</Typography>
                                                <Typography variant='body2'>No, I Did Not</Typography>
                                            </Box>
                                            {copywriteHighlightAddMore ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Name of the company/page?  </Typography>
                                                    <Typography variant='body2' className={styles.textorngTwo}>Company Name</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>
                                    </ListItem>
                                </List>
                            </Paper>

                            <Paper className={`${styles.comWhiteBox} ${styles.submissionInfo}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Submission Information</span>
                                    </Typography>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                    <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formName}`}>
                                            <Typography variant="h6">Terms of Submission</Typography>
                                            <Typography variant="body2">Agreed | Exclusive License</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formNumber}`}>
                                            <Typography variant="h6">User IP address</Typography>
                                            <Typography variant="body2">17.172.224.47</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formTerms}`}>
                                            <Typography variant="h6">Terms of Service</Typography>
                                            <Typography variant="body2">Agreed</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formCountry}`}>
                                            <Typography variant="h6">Country</Typography>
                                            <Typography variant="body2">United States</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formDate}`}>
                                            <Typography variant="h6">Submission date</Typography>
                                            <Typography variant="body2">August 23, 2021 at 11:15:34 PM UTC</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formAcquired}`}>
                                            <Typography variant="h6">Acquired By</Typography>
                                            <Typography variant="body2">Acquisitor name</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol4} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formVsid}`}>
                                            <Typography variant="h6">VSID</Typography>
                                            <Typography variant="body2">17171</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formRevenue}`}>
                                            <Typography variant="h6">Revenue Share:</Typography>
                                            <Typography variant="body2">50%</Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Paper>

                            {/* <Paper className={`${styles.comWhiteBox} ${styles.teamMessage}`}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content1"
                                        id="panel1a-header1"
                                    >
                                        <Box className={styles.paperHeading}>
                                            <Typography variant="h2">
                                                <span>Team Messages</span>
                                            </Typography>
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box className={styles.message_tab}>
                                            <Box className={styles.tab_top}>
                                                <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
                                                    <Tab label="Partner" {...a11yProps(0)} />
                                                    <Tab label="Manager" {...a11yProps(1)} />
                                                    <Tab label="Admin" {...a11yProps(2)} disabled />
                                                </Tabs>
                                                <Button type='button' className={styles.respond_btn}>Respond Now</Button>
                                            </Box>
                                            <Box className={styles.tab_content}>
                                                <CustomTabPanel value={tabValue} index={0}>
                                                    <Typography variant='body1'>
                                                        Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus. Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...
                                                    </Typography>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={tabValue} index={1}>
                                                    <Typography variant='body1'>
                                                        Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus. Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...
                                                    </Typography>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={tabValue} index={2}>
                                                    <Typography variant='body1'>
                                                        Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus. Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...
                                                    </Typography>
                                                </CustomTabPanel>
                                            </Box>
                                        </Box>
                                        <Box className={styles.attached_box}>
                                            <Typography variant='h4'>Attached files:</Typography>
                                            <Button type='button' className={styles.attach_btn}>
                                                <Typography variant='caption' className={styles.ico}>
                                                    <DownloadIcon />
                                                </Typography>
                                                <Typography variant='caption' className={styles.text}>
                                                    5028537_5563370603774986.png
                                                </Typography>
                                            </Button>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Paper> */}

                            <Box className={`${styles.accItems} ${styles.teamMsg}`}>
                                <Accordion
                                    expanded={expanded === "TeamMessages"}
                                    onChange={handleChange("TeamMessages")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "TeamMessages" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="TeamMessagesbh-content"
                                        id="TeamMessagesbh-header"
                                    >
                                        <Typography variant="h2" sx={{ width: '35%', flexShrink: 0 }}><span>Team Messages</span></Typography>
                                        <Stack direction={'row'} alignItems={'center'} className={styles.teambtnGroup}>
                                            <Button>Content Buyer</Button>
                                            <Button>Manager</Button>
                                            <Button>QC Agent</Button>
                                        </Stack>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box className={styles.teamMsgBtngroup}>
                                        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.tabsTopRoot}>
                                            <Tabs value={teamMsg} onChange={handleTeamMsg} aria-label="basic tabs example">
                                                <Tab label="Partner" {...a11yProps(0)} />
                                                <Tab label="Manager" {...a11yProps(1)} />
                                                <Tab label="QC Agent" {...a11yProps(2)} />
                                            </Tabs>
                                            <Button className={styles.openBtn}>Respond <strong>Now</strong></Button>
                                        </Stack>
                                            <Box className={styles.tabPanelSec}>
                                                <CustomTabPanel value={teamMsg} index={0}>
                                                    <Box className={styles.tabpanelInner}>
                                                        <Typography variant='body1'>As <strong>you</strong> messaged the partner, you will be able to keep track of it by clicking here:</Typography>
                                                        <Button className={styles.openBtn}>Open <strong>Now</strong></Button>
                                                    </Box>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg} index={1}>
                                                    Item Two
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg} index={2}>
                                                    Item Three
                                                </CustomTabPanel>
                                            </Box>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.tabsTopRoot}>
                                                <Tabs value={teamMsg1} onChange={handleTeamMsg1} aria-label="basic tabs example">
                                                    <Tab label="Partner" {...a11yProps(0)} />
                                                    <Tab label="Manager" {...a11yProps(1)} />
                                                    <Tab label="QC Agent" {...a11yProps(2)} className={styles.btnDot} />
                                                </Tabs>
                                                <Button className={styles.openBtn}>Respond <strong>Now</strong></Button>
                                            </Stack>
                                            <Box className={`${styles.tabPanelSec} ${styles.difTabPanel}`}>
                                                <CustomTabPanel value={teamMsg1} index={0}>
                                                    <Box className={styles.tabpanelInner}>
                                                        <Typography variant='body1'>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus. Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...</Typography>
                                                        <Box className={styles.fileListArea}>
                                                            <InputLabel>Attached files:</InputLabel>
                                                            <List disablePadding>
                                                                {attachFileLoop.map((item) => {
                                                                    return (
                                                                        <ListItem disablePadding>
                                                                            <figure><DownloadFileIcon /></figure>
                                                                            <Typography variant='overline'>{item?.fileName}</Typography>
                                                                        </ListItem>
                                                                    );
                                                                })}

                                                            </List>
                                                        </Box>

                                                    </Box>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg1} index={1}>
                                                    Item Two
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg1} index={2}>
                                                    Item Three
                                                </CustomTabPanel>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>

                            {/* PARTNERS NOTE */}

                            <Box className={`${styles.accItems} ${styles.noteSec}`}>
                                <Accordion
                                    expanded={expanded === "myNote"}
                                    onChange={handleChange("myNote")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "myNote" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="myNotebh-content"
                                        id="myNotebh-header"
                                    >
                                        <Typography variant="h2"><span>Partner's Note</span></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box className={styles.showNote}>
                                            <Box className={styles.readNote}>
                                                <Typography variant="body1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, toSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, tdsmohas hfdibnf,d hgbdflk,mdffdo...</Typography>
                                                <Stack direction={'row'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'space-between'} className={styles.noteBottmSec}>
                                                    <Box className={styles.noteDate}>
                                                        <CalenderGrayIcon />
                                                        <Typography variant="caption">January 25, 2023</Typography>
                                                    </Box>
                                                    <Stack direction={'row'} alignItems={'center'} className={styles.btnGrpStyled}>
                                                        <Button onClick={handleClickModalOpen}><ReadIcon /> Read</Button>
                                                    </Stack>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>

                            {/* PARTNERS NOTE */}
                        </Box>
                    </Stack>
                </PerfectScrollbar>
            </Box>

           {/* Modal on partner note */}

           <Dialog
                open={modalopen}
                onClose={handleCloseModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent className={styles.readContent}>
                    <Box className={styles.readModalHeader}>
                        <Typography variant='h4'>Date: <Typography variant='caption'>January 25, 2023</Typography></Typography>
                        <Button onClick={handleClose}><CrossIcon /></Button>
                    </Box>
                    <Box className={styles.showNote}>
                        <Box className={styles.readNote}>
                            <Typography variant="body1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, toSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, tdsmohas hfdibnf,d hgbdflk,mdffdo...</Typography>
                        </Box>
                    </Box>
                    <Box className={styles.readModalFooter}>
                        <Button onClick={handleCloseModal}>Close</Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Modal on Click on  Inquire */}

            <Dialog
                open={openFourth}
                onClose={handleCloseFourth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleCloseFourth}>
                            <CrossIcon />
                        </Button>
                        <Box className={modalStyyle.modal_second}>
                            <Box className={modalStyyle.website_form}>
                                <form>
                                    <Box className={modalStyyle.form_group}>
                                        <label>
                                        What would you like to inquire about?
                                        </label>
                                        <Box className={modalStyyle.textareagroup}>
                                            <Button type='button' className={modalStyyle.textCrossBtn}>
                                                <TextAreaCrossIcon />
                                            </Button>
                                            <Typography variant='caption' className={modalStyyle.indicator}>
                                                70 charachters left.
                                            </Typography>
                                            <TextField
                                                multiline
                                                rows={4}
                                            />
                                        </Box>
                                    </Box>
                                    <Box className={modalStyyle.submit_group}>
                                        <Button type='button' className={modalStyyle.proceddBtn}
                                        >Save</Button>
                                        <Button type='button' className={modalStyyle.cancelBtn} onClick={handleCloseFourth}>Cancel</Button>
                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>



            </Dialog>

            {/* MOdal On Click on Approve */}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleClose}>
                            <CrossIcon />
                        </Button>
                        <Box className={modalStyyle.modal_first}>
                            <Box className={modalStyyle.ico} >
                                <ExclametoryGreenicon />
                            </Box>
                            <Typography variant='body1' className={modalStyyle.para}>
                            Are you sure you want to proceed and <strong> Approve</strong> this video?
                            </Typography>
                            <Typography variant='body1' className={modalStyyle.subpara}>
                            <strong> [Manager Name]</strong> is currently inquiring about it.
                            </Typography>
                            <Box className={modalStyyle.btn_holder}>
                                <Button type='button' className={`${modalStyyle.cmn_btn} ${modalStyyle.apprv_btn}`} 
                                    onClick={handleSnackClickTwo({ verticalThree: 'center', horizontalThree: 'center' })}>
                                    Approve
                                </Button>
                                <Button type='button' className={modalStyyle.cancel_btn} onClick={handleClose}>Cancel</Button>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* MOdal On Click on Reject */}

            <Dialog
                open={openSecond}
                onClose={handleCloseSecond}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleCloseSecond}>
                            <CrossIcon />
                        </Button>
                        <Box className={modalStyyle.modal_first}>
                            <Box className={modalStyyle.ico} >
                                <ExclametoryRedIcon />
                            </Box>
                            <Typography variant='body1' className={modalStyyle.para}>
                            Are you sure you want to proceed and <strong> Reject</strong> this video?
                            </Typography>
                            <Typography variant='body1' className={modalStyyle.subpara}>
                            <strong> [Manager Name]</strong> is currently inquiring about it.
                            </Typography>
                            <Box className={modalStyyle.btn_holder}>
                                <Button type='button' className={`${modalStyyle.cmn_btn} ${modalStyyle.reject_btn}`}   
                                    onClick={handleOpenThird}>
                                    Reject
                                </Button>
                                <Button type='button' className={modalStyyle.cancel_btn} onClick={handleClose}>Cancel</Button>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* MOdal On Click on WebsiteOnly */}

            <Dialog
                open={openFourth}
                onClose={handleCloseFourth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleCloseFourth}>
                            <CrossIcon />
                        </Button>
                        <Box className={modalStyyle.modal_first}>
                            <Box className={modalStyyle.ico} >
                                <ExclametoryViolet />
                            </Box>
                            <Typography variant='body1' className={modalStyyle.para}>
                            Are you sure you want to proceed and <strong> Approve</strong> this video for website-only posting?
                            </Typography>
                            <Typography variant='body1' className={modalStyyle.subpara}>
                            <strong> [Manager Name]</strong> is currently inquiring about it.
                            </Typography>
                            <Box className={modalStyyle.btn_holder}>
                                <Button type='button' className={`${modalStyyle.cmn_btn} ${modalStyyle.website_btn}`}
                                    onClick={handleFifthModal}>
                                    Proceed
                                </Button>
                                <Button type='button' className={modalStyyle.cancel_btn} onClick={handleClose}>Cancel</Button>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Modal on Click on  website only */}

            <Dialog
                open={openFifth}
                onClose={handleCloseFifth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleCloseFifth}>
                            <CrossIcon />
                        </Button>
                        <Box className={modalStyyle.modal_second}>
                            <Box className={modalStyyle.website_form}>
                                <form>
                                    <Box className={modalStyyle.form_group}>
                                        <label>
                                            Why should this video be posted on Website Only?
                                        </label>
                                        <Box className={modalStyyle.textareagroup}>
                                            <Button type='button' className={modalStyyle.textCrossBtn}>
                                                <TextAreaCrossIcon />
                                            </Button>
                                            <Typography variant='caption' className={modalStyyle.indicator}>
                                                70 charachters left.
                                            </Typography>
                                            <TextField
                                                multiline
                                                rows={4}
                                            />
                                        </Box>
                                    </Box>
                                    <Box className={modalStyyle.submit_group}>
                                        <Button type='button' className={modalStyyle.proceddBtn}
                                            onClick={handleSnackClick({ vertical: 'center', horizontal: 'center' })}
                                        >Proceed</Button>
                                        <Button type='button' className={modalStyyle.cancelBtn} onClick={handleCloseSecond}>Cancel</Button>
                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>



            </Dialog>

            {/* Modal on Click on  Reject */}

            <Dialog
                open={openThird}
                onClose={handleCloseThird}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalStyyle.dialog_body}>
                        <Button type='button' className={modalStyyle.close_btn} onClick={handleCloseThird}>
                            <CrossIcon />
                        </Button>
                        <Box className={`${modalStyyle.modal_second} ${modalStyyle.modal_third}`}>
                            <Box className={modalStyyle.modal_heading}>
                                <Typography variant='caption' className={modalStyyle.head_left}>Video Rejection</Typography>
                                <Typography variant='body1' className={modalStyyle.head_right}>
                                    <strong>Date:</strong> January 25, 2023 at 09:21 PM UTC

                                </Typography>
                            </Box>
                            <Box className={modalStyyle.website_form}>
                                <form>
                                    <Box className={modalStyyle.form_group}>
                                        <label>
                                            Kindly inform the partner of the reasoning behind the rejection of this video.
                                        </label>
                                        <Box className={modalStyyle.textareagroup}>

                                            <TextField
                                                multiline
                                                rows={5}
                                            />
                                        </Box>
                                    </Box>
                                    <Box className={modalStyyle.submit_group}>
                                        <Button type='button' className={modalStyyle.cancelBtn}
                                            onClick={handleCloseThird}
                                        >Cancel</Button>
                                        <Button type='button' className={modalStyyle.proceddBtn}
                                            onClick={handleSnackClickThree({ verticalThree: 'center', horizontalThree: 'center' })}
                                        >Confirm Rejection</Button>

                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>



            </Dialog>

            {/* Snackbar on Deny & for website only */}
            <Backdrop
                open={snackOpen}
                sx={{ zIndex: '100' }}
                onClick={handleSnackClose}
            >
                <Snackbar
                    open={snackOpen}
                    autoHideDuration={100000}
                    onClose={handleSnackClose}
                    message={
                        <>
                            {/* <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span> */}

                            <p className='textSave textSaveTwo'>Video Approved for <span className='textSaveSpan'> Website Only</span> Posting</p>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "center",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 30px",
                            textAlign: 'center',
                            bottom: "auto !important",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px",

                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpan": {
                                        color: "rgba(171, 71, 188, 1)"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

            {/* Snackbar on Approve */}

            <Backdrop
                open={snackOpenTwo}
                sx={{ zIndex: '100' }}
                onClick={handleSnackCloseTwo}
            >
                <Snackbar
                    open={snackOpenTwo}
                    autoHideDuration={100000}
                    onClose={handleSnackCloseTwo}
                    message={
                        <>
                            {/* <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span> */}

                            <p className='textSave textSaveTwo'>Video   <span className='textSaveSpan'> Successfully</span> Approved</p>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "center",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 30px",
                            textAlign: 'center',
                            bottom: "auto !important",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px",

                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpan": {
                                        color: "rgba(0, 200, 83, 1)"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

            {/* Snackbar on rejection */}

            <Backdrop
                open={snackOpenThree}
                sx={{ zIndex: '100' }}
                onClick={handleSnackCloseThree}
            >
                <Snackbar
                    open={snackOpenThree}
                    autoHideDuration={100000}
                    onClose={handleSnackCloseThree}
                    message={
                        <>
                            {/* <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span> */}

                            <p className='textSave textSaveTwo'>Video  Successfully  <span className='textSaveSpan'> Rejected</span> </p>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "center",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 30px",
                            textAlign: 'center',
                            bottom: "auto !important",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px",

                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpan": {
                                        color: "#FF1744"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

        </>
    )
}
